var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#AAF0C1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -893,
    y: -900.293,
    display: "inline",
    fill: "#FFFFFF",
    width: 1282,
    height: 1265.293
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.9,38.598 9.9,91.05 44.042,66.889    "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.1,38.582 56.719,66.243 90.1,90.359    "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.543,42.665 19.543,36.746 12.4,36.746    "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.801,16.205c-0.659-0.659-1.523-0.988-2.388-0.988c-0.865,0-1.73,0.329-2.389,0.988     c-0.779,0.779-1.609,3.863-2.106,6.882c3.021-0.498,6.105-1.327,6.883-2.105C60.118,19.665,60.118,17.523,58.801,16.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.563,45.168l0.387,0.321l23.645,19.593l4.302-3.044l3.292,2.378L77.86,44.801l0.016-0.014h-0.444V8.02H22.563V45.168z      M31.281,23.667h8.509c-0.11-0.087-0.219-0.175-0.312-0.268c-2.304-2.304-2.304-6.054,0-8.358c2.305-2.304,6.054-2.304,8.358,0     c0.802,0.802,1.409,2.287,1.864,3.878c0.512-1.964,1.226-3.888,2.189-4.85c2.495-2.494,6.555-2.494,9.049,0     c2.495,2.495,2.495,6.554,0,9.049c-0.194,0.194-0.438,0.375-0.703,0.549h8.486v10.019h-2.138v11.256v5.073H55.828H44.172H33.419     v-4.657V33.686h-2.138V23.667z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.192,
    y: 26.688,
    width: 5.616,
    height: 20.307
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.518,23.082c-0.445-2.624-1.156-5.242-1.819-5.904c-0.563-0.563-1.303-0.845-2.043-0.845     c-0.74,0-1.48,0.282-2.043,0.845c-1.126,1.127-1.126,2.959,0,4.086C42.276,21.926,44.894,22.637,47.518,23.082z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.879,65.751 13.816,91.98 87.185,91.98    "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.301,
    y: 26.688,
    width: 9.87,
    height: 3.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.828,
    y: 26.688,
    width: 9.871,
    height: 3.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.828,
    y: 33.686,
    width: 7.732,
    height: 13.309
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "",
    x: 36.44,
    y: 33.686,
    width: 7.732,
    height: 13.309
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.453,42.653 87.581,36.746 80.453,36.746"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift_card.0bc283dfc8e2f98de1a79eb9ffdc17df.svg";
export { ForwardRef as ReactComponent };